import { render, staticRenderFns } from "./scoreRecords.vue?vue&type=template&id=1abc369c&scoped=true"
import script from "./scoreRecords.vue?vue&type=script&lang=js"
export * from "./scoreRecords.vue?vue&type=script&lang=js"
import style0 from "./scoreRecords.vue?vue&type=style&index=0&id=1abc369c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abc369c",
  null
  
)

export default component.exports